<template>
    <transition name="fade">
        <div v-if="visible" class="loading-overlay">
            <div class="loading-spinner"></div>
            <p v-if="text" class="loading-text">{{ $t(text) | capitalize }}...</p>
        </div>
    </transition>
</template>

<script>
export default {
    name: "BaseLoading",
    props: {
        visible: {
            type: [Boolean,Number],
            default: false
        },
        text: {
            type: String,
            default: 'loading'
        }
    }
};
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000000;
    overflow: hidden;

}

.loading-spinner {
    width: 50px;
    height: 50px;
    border: 6px solid #eee;
    border-top-color: #BC1300;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.loading-text {
    margin-top: 1rem;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Animación de entrada/salida */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>